import AbstractAction from 'utils/AbstractAction'

class Action extends AbstractAction {
  _namespace = 'Redemptions'
}

const fetchTremendousRedemptionOptions = new Action('fetchTremendousRedemptionOptions', {
  init: (callback) => ({ callback }),
  success: (payload) => payload,
})

const fetchCryptoRedemptionOptions = new Action('fetchCryptoRedemptionOptions', {
  success: (payload) => payload,
})

const requestTremendousRedemption = new Action('requestTremendousRedemption', {
  init: (amount, destination, recaptchaToken, callback) => ({ amount, destination, recaptchaToken, callback }),
  success: () => ({}),
  failure: (error) => error,
})

const requestExternalRedemption = new Action('requestExternalRedemption', {
  init: (amount, destination, recaptchaToken, callback) => ({ amount, destination, recaptchaToken, callback }),
  success: () => ({}),
  failure: (error) => error,
})

const requestSharesRedemption = new Action('requestSharesRedemption', {
  init: (amount, recaptchaToken, callback) => ({ amount, recaptchaToken, callback }),
  success: () => ({}),
  failure: (error) => error,
})

const requestCryptoRedemption = new Action('requestCryptoRedemption', {
  init: (amount, walletAddress, recaptchaToken, callback) => ({
    amount,
    walletAddress,
    recaptchaToken,
    callback,
  }),
  success: () => ({}),
  failure: (error) => error,
})

const requestCryptoRedemptionQuote = new Action('requestCryptoRedemptionQuote', {
  init: (crypto, callback) => ({ crypto, callback }),
  success: (payload) => payload,
  failure: (error) => error,
})

const clearCryptoRedemptionQuote = new Action('clearCryptoRedemptionQuote', {
  success: () => ({}),
})

export default {
  fetchTremendousRedemptionOptions,
  fetchCryptoRedemptionOptions,
  requestCryptoRedemptionQuote,
  requestCryptoRedemption,
  requestTremendousRedemption,
  requestExternalRedemption,
  requestSharesRedemption,
  clearCryptoRedemptionQuote,
}
